import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from './../AppContext';
import { authenticationService } from './../services/authentication.service';
import ReactWizard from "react-bootstrap-wizard";
import { Admision } from './panels/Admision';
import { Docencia_Grado } from './panels/Docencia_Grado';
import { Docencia_Postgrado } from './panels/Docencia_Postgrado';
import { Gestion_Academica } from './panels/Gestion_Academica';
import { Investigacion } from './panels/Investigacion';
import { Vinculacion } from './panels/Vinculacion';

import { loginRequest } from "../services/authConfig";
import { callMsGraph } from "../services/graph";
import { MsalContext } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";

import { Admision_out } from './panels_out/Admision';
import { Docencia_Grado_out } from './panels_out/Docencia_Grado';
import { Docencia_Postgrado_out } from './panels_out/Docencia_Postgrado';
import { Gestion_Academica_out } from './panels_out/Gestion_Academica';
import { Investigacion_out } from './panels_out/Investigacion';
import { Vinculacion_out } from './panels_out/Vinculacion';
import { Solicitud_General_out } from './panels_out/Solicitud_General';
import { Resumen_final } from './panels_out/Resumen_final';

import { Solicitud_General } from './panels/Solicitud_General';
import "tailwindcss/tailwind.css"
import Swal from 'sweetalert2'
import aviso from './img/svg/Aviso.svg';
import logout from './img/svg/Cerrar sesion.svg';
import { isArray } from 'jquery';
import { Col, Row, Container } from 'react-bootstrap';
import { NavLink } from 'reactstrap';

//import { Tabs, TabNav, TabNavItem, TabContent, TabPanel } from 'react-smarttab'
//import 'react-smarttab/dist/index.css'

const API_URL = process.env.REACT_APP_API_URL;

class FirstStep extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            firstStep: "first step here"
        };
    }

    isValidated() {
        // do some validations
        // decide if you will
        return false;
        // or you will
        // return false;
    }
    render() {
        return (
            <div>
                <Docencia_Grado idprof={this.props.idprof}/></div>
        );

    }
}
class SecondStep extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            secondStep: "second step here"
        };
    }
    isValidated() {
        // do some validations
        // decide if you will
        return true;
        // or you will
        // return false;
    }
    render() {
        return (
            <div>
                <Docencia_Postgrado /></div>
        );
    }
}
class ThirdStep extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            thirdStep: "third step here"
        };
    }
    render() {
        return (
            <div>
                <Investigacion /></div>
        );
    }
}
class FourthStep extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            FourthStep: "fourth step here"
        };
    }
    render() {
        return (
            <div>
                <Vinculacion /></div>
        ); 
    }
}
class FifthStep extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            FifthStep: "Fifth step here"
        };
    }
    render() {
        return (
            <div>
                <Gestion_Academica /></div>
        );
    }
}
class SixthStep extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            SixthStep: "Sixth step here"
        };
    }
    render() {
        return (
            <div>
                <Admision /></div>
        );
    }
}
class SevenStep extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            thirdStep: "Sixth step here"
        };
    } 

    render() {
        return (
            <div>
                En Construccion
            </div>
        );
    }
} 

export class WizardPrincipal extends Component {

    static displayName = WizardPrincipal.name;

    constructor(props) {
        super(props);
        //console.log("*** currentUser = " + JSON.stringify(props));
        this.state = {
            data: [
                //{ stepName: "Docencia - Grado", component: FirstStep },  // if materia_grad is true or actividad_grad is true
                //{ stepName: "Docencia - Postgrado", component: SecondStep }, // if materia_grad is true or actividad_grad is true
                //{ stepName: "Investigacion", component: ThirdStep },
                //{ stepName: "Vinculacion a la Sociedad", component: FourthStep },
                //{ stepName: "Gestion Academica", component: FifthStep },
                //{ stepName: "Admisiones", component: SixthStep ,},
                //{ stepName: "Solicitud unificada", component: SevenStep }
            ], solicitudesDetalle: [], loading: true, idprof: 0, idpersona: 0, anio: 2025,//new Date().getFullYear(),
                idperiodo: 0, terminoPeriodo: "",
            terminoNombre: "", seDesvincula: false,
            cargaAcademica: [],
            cargaAcademica2: [], filas: [], validaciones: [], loading2: false, fin_button: "", ultimocambio: "", currentUser: null, conteo_total:[],
            totalGeneral: [], labelTotal: 0, id_cargadet: 0, valida_out: false, cargapolitecnica: 0,
            cont_A: [], cont_G: [], cont_R: [], cont_P: [], cont_I: [], cont_V: [], cont_MP: [], cont_MR: [], total_profesional: 0, isloading: true,
            horasTotales: 0, horasLicencia: 0, otrasHoras: 0,
            sinObservaciones: false
        };

        this.updateState = this.updateState.bind(this);
        this.updateCarga = this.updateCarga.bind(this);
        this.finishButtonClick = this.finishButtonClick.bind(this);
        this.nextButtonClick = this.nextButtonClick.bind(this);
        this.getSolicitudes = this.getSolicitudes.bind(this);
        this.setSolicitudes = this.setSolicitudes.bind(this);
        this.updateFinal = this.updateFinal.bind(this);
        this.isValidated = this.isValidated.bind(this);

        this.setconteo_final = this.setconteo_final.bind(this);
        this.setconteo_final_mat = this.setconteo_final_mat.bind(this);

        this.calcula_totales = this.calcula_totales.bind(this);

        this.azureLogin = this.azureLogin.bind(this);
        this.azureGetDatosUser = this.azureGetDatosUser.bind(this);
    }


    componentDidMount() {

        // **************************************************** ENTRA ID
        const isAuthenticated = this.context.accounts.length > 0;
        //console.log('isAuthenticated: ', isAuthenticated);

        if (!isAuthenticated) {
            this.azureLogin();
        } else {
            Swal.fire({
                title: 'Buscando su información...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => {
                    Swal.showLoading()
                }
            });

            this.azureGetDatosUser();
		}

        //if (!currentUser) {
        //    this.subscription = authenticationService.currentUser.subscribe(currentUser => {
        //        //console.log(currentUser);

        //        if (currentUser && currentUser.idpersona) {
        //            this.setState({ idprof: currentUser.idpersona, idpersona: currentUser.idpersona, currentUser: currentUser });

        //            this.validaValida(currentUser.idpersona, 2025);

        //            //if (currentDate < new Date(2023, 2, 28, 0, 0, 1, 0) || currentDate > new Date(2023, 3, 20, 0, 0, 0, 0)) {
        //            //    Swal.fire({
        //            //        title: 'Mensaje',
        //            //        text: 'Lo sentimos, el periodo para la validación de carga académica es del 28 de marzo al 20 de abril.',
        //            //        icon: 'error',
        //            //        timer: 10000,
        //            //        timerProgressBar: true,
        //            //        confirmButtonText: 'Ok'
        //            //    });
        //            //} else {
        //            //    this.validaValida(currentUser.idpersona, 2023);  // Descomentar esta linea para activar los paneles y el servicio en el anio de consulta
        //            //}
        //        }
        //    });
        //}

        //const idpersona = currentUser && currentUser.idpersona > 0 ? currentUser.idpersona : this.props.currentUser && this.props.currentUser.idpersona > 0 ? this.props.currentUser.idpersona : this.state.idprof;
        //if (currentUser && currentUser.idpersona > 0) {
        //    this.setState({ idprof: currentUser.idpersona });

        //    this.validaValida(currentUser.idpersona, 2025);

        //    //if (currentDate < new Date(2023, 2, 28, 0, 0, 1, 0) || currentDate > new Date(2023, 3, 20, 0, 0, 0, 0)) {
        //    //    Swal.fire({
        //    //        title: 'Mensaje',
        //    //        text: 'Lo sentimos, el periodo para la validación de carga académica es del 24 de noviembre al 8 de diciembre.',
        //    //        icon: 'error',
        //    //        timer: 10000,
        //    //        timerProgressBar: true,
        //    //        confirmButtonText: 'Ok'
        //    //    });

        //    //} else {
        //    //    this.validaValida(currentUser.idpersona, 2023);  // Descomentar esta linea para activar los paneles y el servicio en el anio de consulta
        //    //}
        //}

    }

    async azureLogin() {
        const msalInstance = this.context.instance;

        await msalInstance.loginRedirect(loginRequest).catch(e => {
            //console.log(e);
        });
    }

	async azureGetDatosUser() {
		const msalInstance = this.context.instance;

		await msalInstance
			.acquireTokenSilent({
				...loginRequest,
				account: this.context.accounts[0],
			})
			.then((response => {
				callMsGraph(response.accessToken).then((response) => {
					//console.log("azureGetDatosUser: ", response);

                    fetch(API_URL + `Login/GetDatosLogin/${encodeURIComponent(response.userPrincipalName)}`)
						.then(response => response.json())
						.then(responseJson => {
							//console.log("responseJson: ", responseJson);

                            this.setState({ idprof: responseJson.idpersona, idpersona: responseJson.idpersona, currentUser: responseJson }, () => {
                                this.validaValida(responseJson.idpersona, this.state.anio);
							});
						});
				});
			}));
	}

    updateCarga(cargaupd, cargaupd2,tipo) {
       

        if (cargaupd2) {
            var carga2 = this.state.cargaAcademica2;
            carga2.push(cargaupd2)
            //calcula el total general para la etiqueta superior 
            var arr_total = this.state.totalGeneral
            cargaupd2.forEach((act) => { 
                arr_total.push(act.totalhoras) 
            }) 
            var sum = 0
            arr_total.forEach((item) => {
                sum = sum + item
            }) 


            this.setState({
                cargaAcademica2: carga2
            });

        }
    }

    updateState(solicitudesUpd) {
        if (solicitudesUpd) {
            var solicitudes = this.state.solicitudesDetalle; 
            /*const actividades = solicitudesUpd.map(su => su.idactividad);
            if (solicitudes.length > 0) {
                solicitudes = this.state.solicitudesDetalle.filter(s => solicitudesUpd.some(su => s.idactividad == su.idactividad));
            }
            else {
                solicitudes = [];
            }
            const solicitudesDetalle = solicitudes.length > 0 ? solicitudes.push(solicitudesUpd) : solicitudesUpd;*/

            //console.log('RECEPCION EN EL WIZARD PRINCIPAL del dato: ' + JSON.stringify(solicitudesUpd))
            solicitudes.push(solicitudesUpd)

            //this.cargapaneles(this.state.idprof, this.state.anio);
            this.setState({
                solicitudesDetalle: solicitudes
            });
            //console.log('OBSERVACIONES DE SOLUCITUD: ' + JSON.stringify(this.state.solicitudesDetalle))
             
        } 
    }

    setconteo_final(tam, amb) {
        let arr_cont=[]
        if (amb === 'R') {
            //arr_cont = this.state.cont_R;
            //arr_cont.push(tam)
            this.setState({
                cont_R: tam
            })
        } else if (amb === 'P') {
            //arr_cont = this.state.cont_P;
            //arr_cont.push(tam)
            this.setState({
                cont_P: tam
            })
        } else if(amb === 'G') {
            this.setState({
                cont_G: tam
            })
        } else if (amb === 'I') {
            this.setState({
                cont_I: tam
            })
        } else if (amb === 'V') {
            this.setState({
                cont_V: tam
            })
        } else
            this.setState({
                cont_A: tam
            })    
    }


    setconteo_final_mat(tam, amb) {
        if (amb === 'R') {
            this.setState({
                cont_MR: tam
            })
        } else {
            this.setState({
                cont_MP: tam
            })
        }
    }

    updateFinal(rowindex, observacion,accion) {

        //console.log('RECIBIENDO EN WIZARD PRIINCIPAL EL CAMMBIO de OBS: ' + observacion + ' PARA RELIZARLO A ' + rowindex)
        // 1. Make a shallow copy of the items
        //let items = [...this.state.solicitudesDetalle]; // COMENTADO SBRODRIG
        let items = this.state.solicitudesDetalle;

        //console.log('SE HARA EL CAMBIO EN' )
        //console.log( items)
        // 2. Make a shallow copy of the item you want to mutate
        //let item = { ...items[rowindex] }; // COMENTADO SBRODRIG
        let item = items[rowindex];

        //console.log(items[rowindex])
        // 3. Replace the property you're intested in
        item.observacion = observacion;
        item.accion = accion;
        //console.log('OBSERACION ' + item.observacion)
        //console.log('ACCION ' + item.accion)
        // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
        items[rowindex] = item;
        //console.log('ITEM CAMBIADO ')
        //console.log( items[rowindex])
        // 5. Set the state to our new copy

        //console.log('APUNTO DE HACER EL CAMBIO: ' + observacion + ' PARA RELIZARLO A ' + rowindex)
        this.setState({ solicitudesDetalle: items }, () => {
            this.cargapaneles(this.state.idprof, this.state.anio, this.state.terminoPeriodo, this.state.cargaAcademica);
        });

        return items;
         
    } 
     
    getSolicitudes(valor) {
        //console.log('ENTRO A GET SOLICITUDES de WIZARD PRINCIPAL A PEDIR DATOS--->' + JSON.stringify(this.state.solicitudesDetalle)        )
            return this.state.solicitudesDetalle;
        
    }

    setSolicitudes(rowindex, idactividad, fromGeneral, idUnico, ambito) {
        var array = this.state.solicitudesDetalle;
        //si la eliminacion viene de la solicitud general
        if (idactividad === 0) {
            array.splice(rowindex, 1);

            // para actualizar el valor del radio button
            var ambitoSplit = ambito.split("|");

            //if (fromGeneral) {
            //    if (ambitoSplit[0] === "M") { // MATERIAS
            //        if (ambitoSplit[1] === "R") {
            //            var cont_MR = this.state.cont_MR;
            //            console.log("cont_MR: ", cont_MR);

            //            console.log("idUnico: ", idUnico);
            //            //var index_MR = cont_MR.findIndex(obj => obj.idactividad === idUnico);
            //            var index_cont = 0;
            //            var index_MR = cont_MR.find(((obj, i) => {
            //                console.log("index: ", i);
            //                console.log("obj: ", obj);
            //                if (obj.idactividad === idUnico) {
            //                    index_cont = i;
            //                }
            //            }));

            //            console.log("index_cont: ", index_cont);
            //            cont_MR[index_MR].validacion = 'si';
            //            this.setState({ cont_MR: cont_MR });

            //        } else if (ambitoSplit[1] === "P") {
            //            var cont_MP = this.state.cont_MP;
            //            var index_MP = this.state.cont_MP.findIndex(x => x.idactividad === idUnico);
            //            cont_MP[index_MP].validacion = 'si';
            //            this.setState({ cont_MP: cont_MP });
            //        }
            //    } else { // ACTIVIDADES
            //        if (ambitoSplit[1] === 'R') {
            //            var cont_R = this.state.cont_R;
            //            var index_R = this.state.cont_R.findIndex(x => x.idUnico === idUnico);
            //            cont_R[index_R].validacion = 'si';
            //            this.setState({ cont_R: cont_R });

            //        } else if (ambitoSplit[1] === 'P') {
            //            var cont_P = this.state.cont_P;
            //            var index_P = this.state.cont_P.findIndex(x => x.idUnico === idUnico);
            //            cont_P[index_P].validacion = 'si';
            //            this.setState({ cont_P: cont_P });

            //        } else if (ambitoSplit[1] === 'G') {
            //            var cont_G = this.state.cont_G;
            //            var index_G = this.state.cont_G.findIndex(x => x.idUnico === idUnico);
            //            cont_G[index_G].validacion = 'si';
            //            this.setState({ cont_G: cont_G });

            //        } else if (ambitoSplit[1] === 'I') {
            //            var cont_I = this.state.cont_I;
            //            var index_I = this.state.cont_I.findIndex(x => x.idUnico === idUnico);
            //            cont_I[index_I].validacion = 'si';
            //            this.setState({ cont_I: cont_I });

            //        } else if (ambitoSplit[1] === 'V') {
            //            var cont_V = this.state.cont_V;
            //            var index_V = this.state.cont_V.findIndex(x => x.idUnico === idUnico);
            //            cont_V[index_V].validacion = 'si';
            //            this.setState({ cont_V: cont_V });

            //        } else if (ambitoSplit[1] === 'A') {
            //            var cont_A = this.state.cont_A;
            //            var index_A = this.state.cont_A.findIndex(x => x.idUnico === idUnico);
            //            cont_A[index_A].validacion = 'si';
            //            this.setState({ cont_A: cont_A });
            //        }
            //    }
            //}
        }
        else { // la eliminacion viene de algun panel mediante su idactividad
            var index = array.map(function (e) { return e.idactividad; }).indexOf(idactividad);
            if (index !== -1) {
                array.splice(index, 1);
			}
        }

        this.cargapaneles(this.state.idprof, this.state.anio, this.state.terminoPeriodo, this.state.cargaAcademica);
        this.setState({ solicitudesDetalle: array });

    }



    busca_accion(accion) {
        if (accion === 'Modificar Carga') {
            return('M')
        } else if (accion === 'Eliminar Carga') {
            return ('E')
        } else if (accion === 'Nueva Carga') {
            return ('C')
        }
    }

    get_actividad(arr) {
        if (isArray(arr)) {
            return (arr[0])
        } else {
            return arr
        }
            
    }

    setacademica2=(arr)=> {
        var filaaqui=[]
        if (isArray(arr)) {
            arr.forEach((element) => {
                element.forEach((element2) => {
                        filaaqui.push({
                            idactividad: element2.idactividad,
                            periodo: element2.periodo,
                            tipo: element2.tipo,
                            descripcion: element2.descripcion,
                            anio: element2.anio,
                        });
                })

            })

            this.setState({
                filas: filaaqui
            })
        }
    }

    get_radios(termino1, termino2, termino3, anio) {
        var respu;
        if (termino2 === "2" && termino1 === "1" && termino3 === "0") {
            return (
                'PAE-' + anio + '\n  PAO-' + anio + '-1\n PAO-' + anio + '-2'
            )
        }
        else if (termino1 === "1") {
            if (termino1 === "1" && termino3 === "0") {
                return (
                    'PAO-' + anio + '-1 \nPAE-' + anio
                );
            } else if (termino2 === "2" && termino1 === "1") {
                return (
                    'PAO-' + anio + '-1 \nPAO-' + anio + '-2'
                );

            } else {
                return (
                    'PAO-' + anio + '-1'
                );
            }
        } else if (termino2 === "2") {
            if (termino2 === "2" && termino1 === "1") {
                return (
                    'PAO-' + anio + '-1\n PAO-' + anio + '-2'
                );

            } else if (termino2 === "2" && termino3 === "0") {
                return (
                    'PAO-' + anio + '-2\n PAE-' + anio
                );
            }
            return (
                'PAO-' + anio + '-2'
            );
        } else if (termino3 === "0") {
            if (termino3 === "0" && termino1 === "1") {
                return (
                    'PAE-' + anio + '\n PAO-' + anio + '-1'
                );

            } else if (termino3 === "0" && termino2 === "2") {
                return (
                    'PAE-' + anio + '\n PAO-' + anio + '-2'
                );
            }
            return (
                'PAE-' + anio
            );
        }
    }
    finishButtonClick() {

        let suma = this.state.cont_A.length + this.state.cont_R.length + this.state.cont_P.length + this.state.cont_I.length + this.state.cont_V.length + this.state.cont_G.length
            + this.state.cont_MP.length + this.state.cont_MR.length;

        let suma_carga = this.state.cargaAcademica.carga.grado.materias.length           + this.state.cargaAcademica.carga.grado.actividades.length + this.state.cargaAcademica.carga.postGrado.materias.length +
                         this.state.cargaAcademica.carga.postGrado.actividades.length    + this.state.cargaAcademica.carga.admisiones.length        + this.state.cargaAcademica.carga.investigacion.length +
                         this.state.cargaAcademica.carga.vinculos.length                 + this.state.cargaAcademica.carga.gestionAcademica.length;
        //console.log(suma + ' ===  ' + suma_carga);
        let restante = suma_carga - suma;
        if (suma === suma_carga) {


            Swal.fire({
                title: '¿Está seguro de enviar?',
                text: "Al enviar usted registrará sus observaciones en el sistema y no tendrá acceso para realizar cambios.",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sí, Enviar',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {


                    if (this.state.fin_button === 'Enviar') {
                        var solicitudes = this.state.solicitudesDetalle;

                        const data = JSON.stringify({
                            "IDPERSONA": this.state.idprof,
                        });

                        // SE COMENTA HASTA QUE ESTÉ APROBADO POR STAC CON TH (DESVINCULACION)
                        //var tipo_validacion = this.state.seDesvincula ? 'DESVINCULACION' : 'VALIDACION';
                        //"IDPERIODO": this.state.anio,   // realizar GET para obtener el id periodo
                        const POST_CabValidacion = JSON.stringify({
                            "IDPERSONA": this.state.idprof,
                            "IDPERIODO": this.state.idperiodo,
                            "TIPO": 'VALIDACION'
                        });

                        // fetch para guardar la carga academia del profesor
                        fetch(API_URL + "TPlnValidacions/", {

                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: POST_CabValidacion,

                        }).then(response => response.json())
                            .then(
                                (responseJson) => {

                                    const solicitudes = this.state.solicitudesDetalle;

                                    //console.log("idplnvalidacion: ", responseJson["idplnvalidacion"]);
                                    if (responseJson["idplnvalidacion"] > 0) {
                                        //insertando las solicitudes

                                        solicitudes.map(acti => {
                                            //console.log('===============MATERIAS ==== DATOS QUE TIENE ACTI===============');
                                            //console.log(acti);

                                            var idact = 0;
                                            var idmat = 0;
                                            var periodopost = "";

                                            if (acti.ambito.split('|')[0] === 'A') {
                                                periodopost = acti.termino; //this.get_radios(acti.periodo.split('|')[0], acti.periodo.split('|')[1], acti.periodo.split('|')[2], acti.anio)
                                                idact = acti.idactividad;
                                            } else {

                                                //console.log('===============MATERIAS==== DATOS QUE TIENE ACTI EN PERIODOO===============');
                                                //console.log(acti.periodo);

                                                idmat = acti.idactividad;
                                                periodopost = acti.termino;

                                                //console.log(periodopost)
                                            }

                                            const POST_detalleValidacion = JSON.stringify({
                                                "idplnvalidacion": responseJson["idplnvalidacion"],
                                                "accion": this.busca_accion(acti.accion),
                                                "periodo": acti.termino,
                                                "tipo": acti.ambito,
                                                "descripcion": this.get_actividad(acti.descripcion),
                                                "observacion": acti.observacion,
                                                "idplncargaacademicadet": this.state.id_cargadet,
                                                "idplanifactividades": idact,
                                                "idcurso": idmat,
                                                "validado": 0,
                                                "idpersonacambio": this.state.idprof
                                            });


                                            fetch(API_URL + "TPlnValidacionDets/", {

                                                method: 'POST',
                                                headers: { 'Content-Type': 'application/json' },
                                                body: POST_detalleValidacion,

                                            }).then(response => response.json())
                                                .then(
                                                    (responseJson) => {
                                                        if (responseJson) {
                                                            //console.log("Respuesta json PLANIFDET :" + responseJson);
                                                        }
                                                        else {
                                                            //console.log("Se presento un error.");
                                                        }
                                                    })

                                        });

                                        const solicitudes_cargas = this.state.cargaAcademica2;
                                        this.setacademica2(solicitudes_cargas)
                                        //insertando las cargas como solicitudes

                                        this.state.filas.map(acti2 => {
                                            //console.log('===============MATERIAS ==== DATOS QUE TIENE ACTI2===============');
                                            //console.log(acti2);

                                            var periodopost = "";
                                            var idact = 0;
                                            var idmat = 0;

                                            if (acti2.tipo.split('|')[0] === 'A') {
                                                periodopost = this.get_radios(acti2.periodo.split('|')[0], acti2.periodo.split('|')[1], acti2.periodo.split('|')[2], acti2.anio);
                                                idact = acti2.idactividad;
                                            } else {

                                                //console.log('===============MATERIAS==== DATOS QUE TIENE ACTI2 EN PERIODOO===============');
                                                //console.log(acti2.periodo);

                                                idmat = acti2.idactividad;
                                                periodopost = acti2.periodo;

                                                //console.log(periodopost);
                                            }
                                            const POST_detalleValidacion2 = JSON.stringify({
                                                "idplnvalidacion": responseJson["idplnvalidacion"],
                                                "accion": 'C',
                                                "periodo": periodopost,
                                                "tipo": acti2.tipo,
                                                "descripcion": acti2.descripcion,
                                                "observacion": 'S/N',
                                                "idplncargaacademicadet": this.state.id_cargadet,
                                                "idplanifactividades": idact,
                                                "idcurso": idmat,
                                                "validado": 1,
                                                "idpersonacambio": this.state.idprof
                                            });

                                            //console.log('===============VER DATOS QUE SE VAN A VALIDACION===============');
                                            //console.log(POST_detalleValidacion2);

                                            var solicitud = this.state.solicitudesDetalle.filter(x => x.idactividad === acti2.idactividad);
                                            //console.log("solicitud: ", solicitud);

                                            if (solicitud.length === 1) {
                                                //console.log('POST NO CARGA PORQUE ESTA EN PETICION===>' + POST_detalleValidacion2);

                                            } else {
                                                //console.log('POST CARGA DE ACTIVIDADE===>' + POST_detalleValidacion2);
                                                fetch(API_URL + "TPlnValidacionDets/", {

                                                    method: 'POST',
                                                    headers: { 'Content-Type': 'application/json' },
                                                    body: POST_detalleValidacion2,

                                                }).then(response => response.json())
                                                    .then(
                                                        (responseJson) => {
                                                            if (responseJson) {
                                                                //console.log("Solicitud de :" + acti2.descripcion);
                                                            }
                                                            else {
                                                                //console.log("Se presento un error.");
                                                            }
                                                        });

                                            }

                                        })

                                        // envio de correo electronico
                                        fetch(API_URL + "Notificaciones/HV/" + this.state.idprof)
                                            .then(response => response.json())
                                            .then(responseJson => {
                                                if (responseJson.strEstado === "S") {
                                                    console.log("se envio correo HV");
                                                } else {
                                                    console.log("no se envio correo HV");
                                                }
                                            });

                                        // SE COMENTA HASTA QUE ESTÉ APROBADO POR STAC CON TH (DESVINCULACION)
                                        //if (solicitudes.length === 0) {
                                        //    console.log("sin observaciones");

                                        //    fetch(API_URL + "Notificaciones/SO/" + this.state.idprof)
                                        //        .then(response => response.json())
                                        //        .then(responseJson => {
                                        //            if (responseJson.strEstado === "S") {
                                        //                console.log("se envio correo SO");
                                        //            } else {
                                        //                console.log("no se envio correo SO");
                                        //            }
                                        //        });
                                        //}

                                    }
                                    else {
                                        //console.log("Ha ocurrido un error al guardar.")
                                    }
                                });

                        // FIN fetch para guardar la carga academia del profesor


                        Swal.fire({
                            title: 'Hecho!',
                            text: 'Validación enviada exitosamente',
                            icon: 'success',
                            timer: 1500,
                            confirmButtonText: 'Ok'
                        })
                        //window.location.reload(false);
                        this.setState({
                            total_profesional: 0,
                            labelTotal: 0,
                            cargapolitecnica: 0, 
                            fin_button: 'Finalizar'
                        })
                        //this.validaValida(this.state.idprof, this.state.anio);
                        this.cargapaneles_out(this.state.idprof, this.state.anio, this.state.cargaAcademica);
                        
                    } else {

                        Swal.fire({
                            title: 'Mensaje',
                            text: 'La validación de carga realizada exitosamente',
                            icon: 'success',
                            confirmButtonText: 'Ok'
                        })
                    }

                }
            })
        } else {
           
            if (this.state.valida_out) {
                Swal.fire({
                    icon: 'success',
                    html: '<h4>Validación académica realizada para este periodo!</h4>',
                    timer: 1500
                });
            } else {
                Swal.fire({
                    icon: 'warning',
                    html: '<h4>Usted tiene '+restante+' asignaturas/actividades por validar.</h4>',
                    timer: 4000
                });
            }
        }
       



    }
    calcula_totales(data) {
        //console.log('TOTALEEEEEEEs', data);
        let profesional = data.carga.postGrado.materias ? data.carga.postGrado.materias.filter(x => x.esCarga === 'N') : [];
        let arr_total = [];
        let gradomat = data.carga.grado.materias.length > 0 ? data.carga.grado.materias.forEach((act) => { arr_total.push(act.totalHoras) }) : 0;
        let gradoact = data.carga.grado.actividades.length > 0 ? data.carga.grado.actividades.forEach((act) => { arr_total.push(act.totalHoras) }) : 0;
        let postGradomat = data.carga.postGrado.materias.length > 0 ? data.carga.postGrado.materias.forEach((act) => { arr_total.push(act.horasTotales) }) : 0;
        let postGradoact = data.carga.postGrado.actividades.length > 0 ? data.carga.postGrado.actividades.forEach((act) => { arr_total.push(act.totalHoras) }) : 0;
        let admisiones = data.carga.admisiones.length > 0 ? data.carga.admisiones.forEach((act) => { arr_total.push(act.horasTotales) }) : 0;
        let investigacion = data.carga.investigacion.length > 0 ? data.carga.investigacion.forEach((act) => { arr_total.push(act.totalHoras) }) : 0;
        let vinculos = data.carga.vinculos.length > 0 ? data.carga.vinculos.forEach((act) => { arr_total.push(act.totalHoras) }) : 0;
        let gestionAcademica = data.carga.gestionAcademica.length > 0 ? data.carga.gestionAcademica.forEach((act) => { arr_total.push(act.totalHoras) }) : 0;

        
        let sum = 0
        arr_total.forEach((item) => {
            sum = sum + item
        });
        //console.log("SUM: ", sum);


        const tot_profesional = profesional ? profesional.map(x => x.horasTotales).reduce((acc2, item2) => (Number(acc2) + Number(item2)), 0) : 0;
        //console.log("tot_profesional: ", tot_profesional);
        if (sum === 0) {

            Swal.fire({
                title: 'Mensaje',
                text: 'Lo sentimos, usted no tiene acceso a este sistema',
                icon: 'error',
                confirmButtonText: 'Ok'
            })
        }
        this.setState({
            total_profesional: tot_profesional,
            labelTotal: sum, loading: false,
            cargapolitecnica: sum - tot_profesional
        })

         
    }

    async cargapaneles(idprof, anio, terminoPeriodo, data) {
        //const response = await fetch(API_URL + 'TblActividades/' + idprof + '/' + anio); 
        this.calcula_totales(data)

        var items = [];
        if (data.paneles && data.paneles.grado === 1) {
            items.push({
                stepName: "Docencia - Grado", component: Docencia_Grado, stepProps: {
                    idprof: idprof, anio: anio, terminoPeriodo: terminoPeriodo, update: this.updateState, updateCarga: this.updateCarga, getSolicitudes: this.getSolicitudes, setSolicitudes: this.setSolicitudes, setconteo_final: this.setconteo_final, setconteo_final_mat: this.setconteo_final_mat,
                    cargaMat: data.carga.grado.materias.length > 0 ? data.carga.grado.materias : [], cargaAct: data.carga.grado.actividades.length > 0 ? data.carga.grado.actividades : []
                }
            })
        }
        if (data.paneles && data.paneles.postGrado === 1) {
          items.push({
            stepName: "Docencia - Postgrado", component: Docencia_Postgrado, stepProps: {
                  idprof: idprof, anio: anio, terminoPeriodo: terminoPeriodo, update: this.updateState, updateCarga: this.updateCarga, getSolicitudes: this.getSolicitudes, setSolicitudes: this.setSolicitudes, setconteo_final: this.setconteo_final, setconteo_final_mat: this.setconteo_final_mat,
              cargaMat: data.carga.postGrado.materias.length > 0 ? data.carga.postGrado.materias : [], cargaAct: data.carga.postGrado.actividades.length > 0 ? data.carga.postGrado.actividades : []
            }
          })
        }
        if (data.paneles && data.paneles.investigacion === 1) {
            items.push({
                stepName: "Investigación", component: <Investigacion idprof={idprof} anio={anio} terminoPeriodo={terminoPeriodo} update={this.updateState} updateCarga={this.updateCarga} getSolicitudes={this.getSolicitudes} setSolicitudes={this.setSolicitudes} setconteo_final={this.setconteo_final} cargaAct={data.carga.investigacion.length > 0 ? data.carga.investigacion : []}
                />
            })
        }
        if (data.paneles && data.paneles.vinculacion === 1) {
            items.push({
                stepName: "Vinculación a la Sociedad", component: <Vinculacion idprof={idprof} anio={anio} terminoPeriodo={terminoPeriodo} update={this.updateState} getSolicitudes={this.getSolicitudes} setSolicitudes={this.setSolicitudes} setconteo_final={this.setconteo_final} updateCarga={this.updateCarga} cargaAct={data.carga.vinculos.length > 0 ? data.carga.vinculos : []}
                />
            })
        }
        if (data.paneles && data.paneles.gestion === 1) {
            items.push({
                stepName: "Gestión Académica", component: Gestion_Academica, stepProps: {
                    idprof: idprof, anio: anio, terminoPeriodo: terminoPeriodo, update: this.updateState, updateCarga: this.updateCarga, getSolicitudes: this.getSolicitudes, setSolicitudes: this.setSolicitudes, setconteo_final: this.setconteo_final,
                    cargaAct: data.carga.gestionAcademica.length > 0 ? data.carga.gestionAcademica : []
                    //solicitudes: this.state.solicitudesDetalle.filter(sd => sd.ambito == "A|G")
                }
            })
        }
        if (data.paneles && data.paneles.admisiones === 1) {
            items.push({ stepName: "Admisiones", component: <Admision idprof={idprof} anio={anio} terminoPeriodo={terminoPeriodo} update={this.updateState} setconteo_final={this.setconteo_final} getSolicitudes={this.getSolicitudes} setSolicitudes={this.setSolicitudes} updateCarga={this.updateCarga} cargaMat={data.carga.admisiones.length > 0 ? data.carga.admisiones : []} />})
        }
        items.push({
            stepName: "Observaciones de mi carga",
            component: Solicitud_General, stepProps: {
                idprof: idprof, anio: anio, terminoPeriodo: terminoPeriodo, update: this.updateState, getSolicitudes: this.getSolicitudes, setSolicitudes: this.setSolicitudes,
                cargaMat: data.carga.grado.materias.length > 0 ? data.carga.grado.materias : [], cargaAct: data.carga.grado.actividades.length > 0 ? data.carga.grado.actividades : [],
                observaciones: this.state.solicitudesDetalle, updateFinal: this.updateFinal
            }
        });
        
        this.setState({
            data: items, loading: false, cargaAcademica: data, id_cargadet: data.idCargaDet, valida_out: false
        });
    }

    async cargapaneles_out(idprof, anio, data) {

        this.setState({
            total_profesional: 0,
            labelTotal: 0,
            cargapolitecnica: 0
        })

        this.calcula_totales(data)
        var items = [];
        if (data.paneles && data.paneles.grado === 1) {
            items.push({
                stepName: "Docencia - Grado", component: Docencia_Grado_out, stepProps: {
                    idprof: idprof, anio: anio, update: this.updateState, updateCarga: this.updateCarga, getSolicitudes: this.getSolicitudes,
                    cargaMat: data.carga.grado.materias.length > 0 ? data.carga.grado.materias : [], cargaAct: data.carga.grado.actividades.length > 0 ? data.carga.grado.actividades : []
                }
            })
        }
        if (data.paneles && data.paneles.postGrado === 1) {
            items.push({
                stepName: "Docencia - Postgrado", component: <Docencia_Postgrado_out idprof={idprof} anio={anio} update={this.updateState}
                    updateCarga={this.updateCarga} getSolicitudes={this.getSolicitudes}
                    cargaMat={data.carga.postGrado.materias.length > 0 ? data.carga.postGrado.materias : []} cargaAct={data.carga.postGrado.actividades.length > 0 ? data.carga.postGrado.actividades : []}
                />
            })
        }
        if (data.paneles && data.paneles.investigacion === 1) {
            items.push({
                stepName: "Investigación", component: <Investigacion_out idprof={idprof} anio={anio} update={this.updateState} updateCarga={this.updateCarga} cargaAct={data.carga.investigacion.length > 0 ? data.carga.investigacion : []}
                />
            })
        }
        if (data.paneles && data.paneles.vinculacion === 1) {
            items.push({
                stepName: "Vinculación a la Sociedad", component: <Vinculacion_out idprof={idprof} anio={anio} update={this.updateState} updateCarga={this.updateCarga} cargaAct={data.carga.vinculos.length > 0 ? data.carga.vinculos : []}
                />
            })
        }
        if (data.paneles && data.paneles.gestion === 1) {
            items.push({
                stepName: "Gestión Académica", component: Gestion_Academica_out, stepProps: {
                    idprof: idprof, anio: anio, update: this.updateState, updateCarga: this.updateCarga, getSolicitudes: this.getSolicitudes,
                    cargaAct: data.carga.gestionAcademica.length > 0 ? data.carga.gestionAcademica : []
                    //solicitudes: this.state.solicitudesDetalle.filter(sd => sd.ambito == "A|G")
                }
            })
        }
        if (data.paneles && data.paneles.admisiones === 1) {
            items.push({ stepName: "Admisiones", component: <Admision_out idprof={idprof} anio={anio} update={this.updateState} updateCarga={this.updateCarga} cargaMat={data.carga.admisiones.length > 0 ? data.carga.admisiones : []} /> })
        }
        items.push({
            stepName: "Observaciones de mi carga",
            component: Solicitud_General_out, stepProps: {
                idprof: idprof, anio: anio, idcargadet: data.idCargaDet
            }
        });

        this.setState({
            data: items, fin_button: 'Finalizar', loading: false, cargaAcademica: data, id_cargadet: data.idCargaDet, valida_out: true, isloading:false
        });

    }


    nextButtonClick() {
        //console.log('hizo boton en click SIGUIENTE');
        //if (
        //    (this.props.validate && ((this.refs[this.props.steps[this.state.currentStep].stepName].isValidated !== undefined &&
        //        await this.refs[this.props.steps[this.state.currentStep].stepName].isValidated()) || this.refs[this.props.steps[this.state.currentStep].stepName].isValidated === undefined)) ||
        //    this.props.validate === undefined || !this.props.validate
        //)
    }

     isValidated() {
       
            return false
    }

    renderPanelesDatos(data) {

        let contenido = <> </>; 
        let items = []; 
        if (this.state.fin_button === 'Enviar') {
            contenido =this.state.data.length !== 0 ? <ReactWizard
                steps={this.state.data}
                nextButtonText="Siguiente"
                previousButtonText="Anterior"
                finishButtonText={this.state.fin_button}
                title=""
                /*description="This will help you split a complicated flow or a complicated form in multiple steps."*/
                headerTextCenter
                validate
                //validate_next={this.isValidated }
                // nextButtonText={this.updateState} 
                finishButtonClick={this.finishButtonClick}
                navSteps /> : <></> 
            items.push(contenido)
        } else {
            //items.push(<h2>holi</h2>)
            Swal.hideLoading();
            Swal.close();
            let data = this.state.cargaAcademica;
            let datac = this.state.cargaAcademica.idCargaDet;
            let idprof = this.state.idprof;
            let anio = this.state.anio;

            contenido = datac ? <Resumen_final idcargadet={datac} rechazos={this.state.cargaAcademica.validaciones}> </Resumen_final> : <></>
            items.push(contenido)

            if (data.paneles && data.paneles.grado === 1) {
                items.push(<><br /><br /><Row><br /><br /><Col md="7"><h4 className='resumen'>RESUMEN DE CARGA ACADÉMICA DEL ÁMBITO DOCENCIA DE GRADO VALIDADA</h4></Col><Col md="5"><hr /></Col></Row></>)
                items.push(<Docencia_Grado_out idprof={idprof} anio={anio} update={this.updateState} updateCarga={this.updateCarga} getSolicitudes={this.getSolicitudes} cargaMat={data.carga.grado.materias.length > 0 ? data.carga.grado.materias : []} cargaAct={data.carga.grado.actividades.length > 0 ? data.carga.grado.actividades : []} />)
            }
            if (data.paneles && data.paneles.postGrado === 1) {
                items.push(<><br /><br /><Row><br /><Col md="7"><h4 className='resumen'>RESUMEN DE CARGA ACADÉMICA DEL ÁMBITO DOCENCIA DE POSTGRADO VALIDADA</h4></Col><Col md="5"><hr /></Col></Row></>)
                items.push(<Docencia_Postgrado_out idprof={idprof} anio={anio} update={this.updateState} updateCarga={this.updateCarga} getSolicitudes={this.getSolicitudes} cargaMat={data.carga.postGrado.materias.length > 0 ? data.carga.postGrado.materias : []} cargaAct={data.carga.postGrado.actividades.length > 0 ? data.carga.postGrado.actividades : []} />)
            }
            if (data.paneles && data.paneles.investigacion === 1) {
                items.push(<><br /><br /><Row><br /><Col md="7"><h4 className='resumen'>RESUMEN DE CARGA ACADÉMICA DEL ÁMBITO DOCENCIA DE INVESTIGACIÓN VALIDADA</h4></Col><Col md="5"><hr /></Col></Row></>)
                items.push(<Investigacion_out idprof={idprof} anio={anio} update={this.updateState} updateCarga={this.updateCarga} cargaAct={data.carga.investigacion.length > 0 ? data.carga.investigacion : []} />)
            }
            if (data.paneles && data.paneles.vinculacion === 1) {
                items.push(<><br /><br /><Row><br /><Col md="7"><h4 className='resumen'>RESUMEN DE CARGA ACADÉMICA DEL ÁMBITO VINCULACIÓN VALIDADA</h4></Col><Col md="5"><hr /></Col></Row></>)
                items.push(<Vinculacion_out idprof={idprof} anio={anio} update={this.updateState} updateCarga={this.updateCarga} cargaAct={data.carga.vinculos.length > 0 ? data.carga.vinculos : []} />)
            }
            if (data.paneles && data.paneles.gestion === 1) {
                items.push(<><br /><br /><Row><br /><Col md="7"><h4 className='resumen'>RESUMEN DE CARGA ACADÉMICA DEL ÁMBITO GESTIÓN ACADÉMICA VALIDADA</h4></Col><Col md="5"><hr /></Col></Row></>)
                items.push(<Gestion_Academica_out idprof={idprof} anio={anio} update={this.updateState} updateCarga={this.updateCarga} getSolicitudes={this.getSolicitudes} cargaAct={data.carga.gestionAcademica.length > 0 ? data.carga.gestionAcademica : []} />)
            }
            if (data.paneles && data.paneles.admisiones === 1) {
                items.push(<><br /><br /><Row><br /><Col md="7"><h4 className='resumen'>RESUMEN DE CARGA ACADÉMICA DEL ÁMBITO DOCENCIA DE ADMISIÓN VALIDADA</h4></Col><Col md="5"><hr /></Col></Row></>)
                items.push(<Admision_out idprof={idprof} anio={anio} update={this.updateState} updateCarga={this.updateCarga} cargaMat={data.carga.admisiones.length > 0 ? data.carga.admisiones : []} />)
            }   
        }



        return (
            <>
                {items}
            </>

        );
    }

    render() {
        //console.log('WizardPrincipal render state solicitudesDetalle = ' + JSON.stringify(this.state.solicitudesDetalle));
        const currentUser = this.state.currentUser; //this.context;
        let contents = this.state.data.length === 0 ? Swal.showLoading() : this.renderPanelesDatos(this.state.data); //this.state.loading ? Swal.showLoading() : this.renderPanelesDatos(this.state.data)

        const horasTPL = this.state.horasTotales + this.state.horasLicencia;

        //this.calcula_totales(this.state.cargaAcademica)
        return (
           
            <div>
                        <Row>
                            <Col md="12">
                                <div className="px-1 float-right txt-notify">{/* {this.state.ultimocambio.split('.')[0].replace('T', ' ')}&nbsp;&nbsp;*/}
                                <NavLink tag={Link} className="text-dark" to="/logout"><img className="salir-logo" src={logout} /></NavLink>
                                    <br />
                                </div>
                            {
                            this.state.labelTotal === 0 ?

                                <h4>Usted no tiene acceso a este sistema</h4> :<>
                                    {/*<div className="rcorners1 ">*/}
                                    {/*<div className="px-1"><img className="chat-notification-logo" src={aviso} /></div>*/}
                                        {/*<div className="px-1 txt-notify">Validaci&oacute;n de Carga de Trabajo Polit&eacute;cnica |  Evaluaci&oacute;n integral 2023</div>*/}
                                    {/*</div>*/}

                                    <br /><br />
                                    {this.state.cargaAcademica.validado === 1 ?
                                        <Row>
                                            <Col className="inline-grid grid-cols-1" sm="12">
                                                {this.state.terminoPeriodo === "2S" ?
                                                    <div className="px-1 bg-total-general4" style={{ height: "50px !important" }}>
                                                        <div className="px-1"><img className="chat-notification-logo" src={aviso} /></div>
                                                        Usted ya ha realizado la validaci&oacute;n del {this.state.terminoNombre}
                                                    </div>
                                                    :
                                                    <div className="px-1 bg-total-general4" style={{ height: "50px !important" }}>
                                                        <div className="px-1"><img className="chat-notification-logo" src={aviso} /></div>
                                                        Usted ya ha realizado la validaci&oacute;n del año {this.state.anio}
                                                    </div>
                                                }  
                                            </Col>
                                        </Row>
                                        :
                                        <Row>
                                            <Col className="inline-grid grid-cols-1" sm="12">
                                                {this.state.terminoPeriodo === "2S" ? 
                                                    <div className="px-1 bg-total-general4" style={{ height: "50px !important" }}>
                                                        <div className="px-1"><img className="chat-notification-logo" src={aviso} /></div>
                                                        Usted va a realizar la validaci&oacute;n de su carga del {this.state.terminoNombre} , en caso que necesite realizar cambios en su carga acad&eacute;mica del PAO {this.state.anio}-1 y del PAE {this.state.anio} comunicarse con su coordinador de carrera
                                                    </div>
                                                    :
                                                    <div className="px-1 bg-total-general4" style={{ height: "50px !important" }}>
                                                        <div className="px-1"><img className="chat-notification-logo" src={aviso} /></div>
                                                        Usted va a realizar la validaci&oacute;n de su carga del año {this.state.anio}
                                                    </div>
                                                }
                                            </Col>
                                        </Row>
                                    }

                                    {/* SE COMENTA HASTA QUE ESTÉ APROBADO POR STAC CON TH (DESVINCULACION) */}
                                    {/*{((this.state.valida_out || this.state.cargaAcademica.validado === 1)*/}
                                        {/*&& (this.state.cargaAcademica.validaciones === null && this.state.solicitudesDetalle.length === 0))*/}
                                        {/*&& (*/}
                                        {/*<Row>*/ }
                                            {/*<Col className="inline-grid grid-cols-1" sm="12">*/}
                                                {/*<div className="px-1 bg-total-general4" style={{ height: "50px !important" }}>*/}
                                                {/*    <div className="px-1"><img className="chat-notification-logo" src={aviso} /></div>*/}
                                                {/*    Usted puede realizar la autoevaluaci&oacute;n, de clic <a href="https://www.espol.edu.ec/" target="_blank">aqu&iacute;</a> para dirigirse al sitio web.*/}
                                                {/*</div>*/}
                                            {/*</Col>*/}
                                        {/*</Row>*/}
                                    {/*)}*/}

                                    {/*<div>*/}
                                        {/*<Container className="fuente-modal" fluid>*/}
                                        {/*    {this.state.total_profesional === 0 ?*/}
                                        {/*        <Row>*/}
                                        {/*            <Col className="inline-grid grid-cols-1" sm="6">*/}
                                        {/*                <div className="px-1 bg-total-general3"><i>Carga Politécnica Total:</i> <b>{this.state.labelTotal.toLocaleString('en', { maximumFractionDigits: 2 })} Horas/año académico</b></div>*/}
                                        {/*            </Col>*/}
                                        {/*            <Col className="inline-grid grid-cols-1" sm="6">*/}
                                        {/*                <div className="px-1 bg-total-general2"><i>Carga Politécnica:</i> <b>{this.state.cargapolitecnica.toLocaleString('en', { maximumFractionDigits: 2 })} Horas/año académico</b><br /><div className="minifuente"> (clases y otras actividades de acuerdo al CTP )</div></div>*/}
                                        {/*            </Col>*/}

                                        {/*        </Row>*/}
                                        {/*        : <Row>*/}
                                        {/*            <Col className="inline-grid grid-cols-1" sm="4">*/}
                                        {/*                <div className="px-1 bg-total-general3"><i>Total horas politécnicas:</i> <b>{this.state.labelTotal.toLocaleString('en', { maximumFractionDigits: 2 })} Horas/año académico</b></div>*/}
                                        {/*            </Col>*/}
                                        {/*            <Col className="inline-grid grid-cols-1" sm="4">*/}
                                        {/*                <div className="px-1 bg-total-general2"><i>Total horas planificadas:</i> <b>{this.state.cargapolitecnica.toLocaleString('en', { maximumFractionDigits: 2 })} Horas/año académico</b><br /><div className="minifuente"> (clases y otras actividades de acuerdo al CTP )</div></div>*/}
                                        {/*            </Col>*/}
                                        {/*            <Col className="inline-grid grid-cols-1" sm="4">*/}
                                        {/*                <div className="px-1 bg-total-general1"><i>Total horas de actividades independientes remuneradas:</i> <b>{this.state.total_profesional.toLocaleString('en', { maximumFractionDigits: 2 })} Horas/año académico</b></div>*/}
                                        {/*            </Col>*/}
                                        {/*        </Row>}*/}

                                        {/*</Container>*/}
                                    {/*</div>*/}

                                    <div>
                                        <Container className="fuente-modal" fluid>
                                            <Row>
                                                <Col className="inline-grid grid-cols-1" sm="3" style={{ paddingRight: "5px" }}>
                                                    <div className="px-1 bg-total-general3"><i>Total horas planificadas + Licencias:</i> <b>{horasTPL.toLocaleString('en', { maximumFractionDigits: 2 })} Horas/año académico</b></div>
                                                </Col>
                                                <Col className="inline-grid grid-cols-1" sm="3" style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                                                    <div className="px-1 bg-total-general2"><i>Total horas planificadas:</i> <b>{this.state.horasTotales.toLocaleString('en', { maximumFractionDigits: 2 })} Horas/año académico</b><br /></div> {/*<div className="minifuente"> (clases y otras actividades de acuerdo al CTP )</div>*/}
                                                </Col>
                                                <Col className="inline-grid grid-cols-1" sm="3" style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                                                    <div className="px-1 bg-total-general2"><i>Horas de licencia:</i> <b>{this.state.horasLicencia.toLocaleString('en', { maximumFractionDigits: 2 })} Horas/año académico</b></div>
                                                </Col>
                                                <Col className="inline-grid grid-cols-1" sm="3" style={{ paddingLeft: "5px" }}>
                                                    <div className="px-1 bg-total-general3"><i>Horas de actividades independientes remunerada:</i> <b>{this.state.total_profesional.toLocaleString('en', { maximumFractionDigits: 2 })} Horas/año académico</b></div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                
                                            </Row>
                                        </Container>
                                    </div>
                                    {contents}
                               </>
                            }
                            </Col>
                    </Row>
            </div>
        );
    }
     

    // YA NO SE USA - PARA VERIFICAR SI ESTA DESVINCULADO
    //async checkHabilitado(idpersona, anio) {

    //    var currentDate = new Date();

    //    const responseDesv = await fetch(API_URL + 'carga/CheckDesvinculacion/' + idpersona);
    //    const responseDesvJson = await responseDesv.json();
    //    //console.log("desvinculacion: ", responseDesvJson);

    //    if (responseDesvJson.idpersona > 0 && new Date(responseDesvJson.fechafin) >= currentDate) {
    //        this.validaValida(idpersona, anio);

    //    } else if (currentDate < new Date(2023, 2, 28, 0, 0, 1, 0) || currentDate > new Date(2023, 3, 20, 0, 0, 0, 0)) {
    //        Swal.fire({
    //            title: 'Mensaje',
    //            text: 'Lo sentimos, el periodo para la validación de carga académica es del 24 de noviembre al 8 de diciembre.',
    //            icon: 'error',
    //            timer: 10000,
    //            timerProgressBar: true,
    //            confirmButtonText: 'Ok'
    //        });
    //    } else {
    //        this.validaValida(idpersona, anio);
    //    }
    //}

    async validaValida(idpersona, anio) {
        /*const response = await fetch(API_URL + 'TPlnValidacions/' + idpersona + '/' + anio, { 'headers': { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.state.currentUser.token}` } })
        const respuesta = await response.json();
        const timeElapsed = Date.now();
        const data = respuesta.filter(x => x.idpersona === idpersona);
        console.log(data)*/
        //console.log(this.context);
        //console.log(API_URL + 'carga/' + idpersona + '/' + anio);

        var currentDate = new Date();

        const responsePeriodo = await fetch(API_URL + 'carga/GetParametrosValidacion');
        const responseJsonParametros = await responsePeriodo.json();
        const responseJsonPeriodo = responseJsonParametros.periodoCompleto; 
        //console.log("responseJsonParametros: ", responseJsonParametros);

        //const responseDesv = await fetch(API_URL + 'carga/CheckDesvinculacion/' + idpersona);
        //const responseDesvJson = await responseDesv.json();
        //console.log("desvinculacion: ", responseDesvJson);

        const response2 = await fetch(API_URL + 'carga/' + idpersona + '/' + anio);
        const respuesta2 = await response2.json();
        const data_json = respuesta2;
        //console.log("data_json: ", data_json);

        // SE COMENTA HASTA QUE ESTÉ APROBADO POR STAC CON TH (DESVINCULACION)
        //if (data_json.validado === 1) {

        //    if (data_json) {
        //        Swal.fire({
        //            icon: 'success',
        //            html: '<h4>Datos adquiridos!</h4>',
        //            timer: 1200
        //        });
        //    }

        //    this.cargapaneles_out(idpersona, anio, data_json);
        //    this.setState({ fin_button: 'Finalizar', idperiodo: responseJsonPeriodo.idperiodo, terminoNombre: responseJsonParametros.terminoNombre, terminoPeriodo: responseJsonPeriodo.termino, horasTotales: data_json.horasTotal, horasLicencia: data_json.horasLicencia, otrasHoras: data_json.otrasHoras });

        //} else if (responseDesvJson.idpersona > 0) { 

        //    this.cargapaneles(idpersona, anio, responseJsonPeriodo.termino, data_json);
        //    this.setState({ fin_button: 'Enviar', idperiodo: responseJsonPeriodo.idperiodo, terminoNombre: responseJsonParametros.terminoNombre, terminoPeriodo: responseJsonPeriodo.termino, ultimocambio: '', horasTotales: data_json.horasTotal, horasLicencia: data_json.horasLicencia, otrasHoras: data_json.otrasHoras, seDesvincula: true });

        //} else if (currentDate < new Date(responseJsonParametros.fechaInicio) || currentDate > new Date(responseJsonParametros.fechaFin)) {

        //    Swal.fire({
        //        title: 'Mensaje',
        //        text: 'Lo sentimos, el periodo para la validación de carga académica es del 24 de noviembre al 8 de diciembre.',
        //        icon: 'error',
        //        timer: 10000,
        //        timerProgressBar: true,
        //        confirmButtonText: 'Ok'
        //    });

        //} else {

        //    this.cargapaneles(idpersona, anio, responseJsonPeriodo.termino, data_json);
        //    this.setState({ fin_button: 'Enviar', idperiodo: responseJsonPeriodo.idperiodo, terminoPeriodo: responseJsonPeriodo.termino, ultimocambio: '', horasTotales: data_json.horasTotal, horasLicencia: data_json.horasLicencia, otrasHoras: data_json.otrasHoras });
        //}


        // PRUEBA CON NUEVA TABALA DE FECHA INICIO Y FECHA FIN
        if (currentDate < new Date(responseJsonParametros.fechaInicio) || currentDate > new Date(responseJsonParametros.fechaFin)) {
            Swal.fire({
                title: 'Mensaje',
                text: 'Lo sentimos, el periodo para la validación de carga académica ha terminado.',
                icon: 'error',
                timer: 10000,
                timerProgressBar: true,
                confirmButtonText: 'Ok'
            });
        } else {
            // ANTES LA FUNCION TENIA UNICAMENTE ESTA PARTE
            if (data_json.validado === 1) {

                if (data_json) {
                    Swal.fire({
                        icon: 'success',
                        html: '<h4>Datos adquiridos!</h4>',
                        timer: 1200
                    });
                }

                this.cargapaneles_out(idpersona, anio, data_json);
                this.setState({ fin_button: 'Finalizar', idperiodo: responseJsonPeriodo.idperiodo, terminoPeriodo: responseJsonPeriodo.termino, terminoNombre: responseJsonPeriodo.nombre, horasTotales: data_json.horasTotal, horasLicencia: data_json.horasLicencia, otrasHoras: data_json.otrasHoras });

            } else {

                this.cargapaneles(idpersona, anio, responseJsonPeriodo.termino, data_json);
                this.setState({ fin_button: 'Enviar', idperiodo: responseJsonPeriodo.idperiodo, terminoPeriodo: responseJsonPeriodo.termino, terminoNombre: responseJsonPeriodo.nombre, ultimocambio: '', horasTotales: data_json.horasTotal, horasLicencia: data_json.horasLicencia, otrasHoras: data_json.otrasHoras });
            }
        }
    }

}
WizardPrincipal.contextType = MsalContext;